export default "__VITE_ASSET__1d21c3a6__"